/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { ProposedActionItem } from "./ProposedActionItem";
import {
  ProposedActionItemFromJSON,
  ProposedActionItemFromJSONTyped,
  ProposedActionItemToJSON,
  ProposedActionItemToJSONTyped,
} from "./ProposedActionItem";
import type { MeetingParticipant } from "./MeetingParticipant";
import {
  MeetingParticipantFromJSON,
  MeetingParticipantFromJSONTyped,
  MeetingParticipantToJSON,
  MeetingParticipantToJSONTyped,
} from "./MeetingParticipant";

/**
 *
 * @export
 * @interface CarrierMeetingPreview
 */
export interface CarrierMeetingPreview {
  /**
   *
   * @type {string}
   * @memberof CarrierMeetingPreview
   */
  carrierIdentifier: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeetingPreview
   */
  jamieMeetingId: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeetingPreview
   */
  jamieUrl: string;
  /**
   *
   * @type {string}
   * @memberof CarrierMeetingPreview
   */
  title?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof CarrierMeetingPreview
   */
  meetingDate?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof CarrierMeetingPreview
   */
  summaryShort?: string | null;
  /**
   *
   * @type {string}
   * @memberof CarrierMeetingPreview
   */
  summaryMarkdown?: string | null;
  /**
   *
   * @type {Array<MeetingParticipant>}
   * @memberof CarrierMeetingPreview
   */
  participants: Array<MeetingParticipant>;
  /**
   *
   * @type {Array<ProposedActionItem>}
   * @memberof CarrierMeetingPreview
   */
  proposedActionItems: Array<ProposedActionItem>;
}

/**
 * Check if a given object implements the CarrierMeetingPreview interface.
 */
export function instanceOfCarrierMeetingPreview(
  value: object,
): value is CarrierMeetingPreview {
  if (
    !("carrierIdentifier" in value) ||
    value["carrierIdentifier"] === undefined
  )
    return false;
  if (!("jamieMeetingId" in value) || value["jamieMeetingId"] === undefined)
    return false;
  if (!("jamieUrl" in value) || value["jamieUrl"] === undefined) return false;
  if (!("participants" in value) || value["participants"] === undefined)
    return false;
  if (
    !("proposedActionItems" in value) ||
    value["proposedActionItems"] === undefined
  )
    return false;
  return true;
}

export function CarrierMeetingPreviewFromJSON(
  json: any,
): CarrierMeetingPreview {
  return CarrierMeetingPreviewFromJSONTyped(json, false);
}

export function CarrierMeetingPreviewFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CarrierMeetingPreview {
  if (json == null) {
    return json;
  }
  return {
    carrierIdentifier: json["carrierIdentifier"],
    jamieMeetingId: json["jamieMeetingId"],
    jamieUrl: json["jamieUrl"],
    title: json["title"] == null ? undefined : json["title"],
    meetingDate: json["meetingDate"] == null ? undefined : json["meetingDate"],
    summaryShort:
      json["summaryShort"] == null ? undefined : json["summaryShort"],
    summaryMarkdown:
      json["summaryMarkdown"] == null ? undefined : json["summaryMarkdown"],
    participants: (json["participants"] as Array<any>).map(
      MeetingParticipantFromJSON,
    ),
    proposedActionItems: (json["proposedActionItems"] as Array<any>).map(
      ProposedActionItemFromJSON,
    ),
  };
}

export function CarrierMeetingPreviewToJSON(json: any): CarrierMeetingPreview {
  return CarrierMeetingPreviewToJSONTyped(json, false);
}

export function CarrierMeetingPreviewToJSONTyped(
  value?: CarrierMeetingPreview | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    carrierIdentifier: value["carrierIdentifier"],
    jamieMeetingId: value["jamieMeetingId"],
    jamieUrl: value["jamieUrl"],
    title: value["title"],
    meetingDate: value["meetingDate"],
    summaryShort: value["summaryShort"],
    summaryMarkdown: value["summaryMarkdown"],
    participants: (value["participants"] as Array<any>).map(
      MeetingParticipantToJSON,
    ),
    proposedActionItems: (value["proposedActionItems"] as Array<any>).map(
      ProposedActionItemToJSON,
    ),
  };
}
